import { computed, type ComputedRef } from 'vue'
import { useAuth } from '@/composables/useAuth'

/**
 * Kommt der, der gerade zusieht, von außen?
 *
 * „Von außen" heißt: über den Kommentarlink (`gast`) oder als Kundenzugang
 * (`client`). Für ihn fällt in den Notizen alles weg, was die Sichtbarkeit
 * betrifft — er sieht ohnehin nur die eigenen Notizen und die, die wir für ihn
 * freigegeben haben. Ein Wähler, der nur eine sinnvolle Stellung hat, ist kein
 * Wähler, und ein Filter über etwas, das er nicht sehen kann, liefert eine
 * leere Liste ohne erkennbaren Grund.
 *
 * Warum als eigene Datei: Dieselbe Zeile stand an drei Stellen (neue Notiz,
 * offener Faden, Liste). Beim Umbau am 15.08.2026 wurden zwei davon angefasst
 * und die dritte vergessen, und genau die zeigte dem Kunden dann einen Filter
 * „Sichtbar für: Nur uns / Auch der Kunde" (David).
 *
 * Die GRENZE zieht das hier nicht, die zieht der Server
 * (`Domain/Annotation/Sichtbarkeit`). Das hier ist nur die Führung.
 */
export function useVonAussen(): ComputedRef<boolean> {
  const { user } = useAuth()
  return computed(
    () => user.value?.role === 'gast' || user.value?.role === 'client',
  )
}
